import { render, staticRenderFns } from "./Arsip.vue?vue&type=template&id=36fd9f5d&"
import script from "./Arsip.vue?vue&type=script&lang=js&"
export * from "./Arsip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports